import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import TableContainer from '@material-ui/core/TableContainer';
import { getUser } from 'src/utils/Common';
import {
  getTasksRequest
} from '../../store/actions';
import axios from 'src/utils/axios';
import { connect } from 'react-redux';

const useStyles = makeStyles(theme => ({
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#BFCFE7'
    }
  },
  hover: {},
  tableHeaderStyle: {
    fontFamily: 'Arial, sans-serif',
    color: '#071952'
  },
  divStyle: {
    padding: '10px',
    margin: '10px',
    border: '1px solid #071952',
    borderRadius: '8px'
  }
}));

const RecentSearches = ({ recentCasesSearches, recentConsumerSearches, onRecentSearchClick,getTasksRequest }) => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const history = useHistory();
  const SessionUser = getUser();

  function handleRouteCases(workOrderId) {
    axios
      .get('/GetConsumerByWorkOrderId/' + workOrderId + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
      .then(res => {
        const response = JSON.stringify(res.data[0]);
        sessionStorage.removeItem('SearhResult');
        sessionStorage.setItem('SearhResult', response);
        sessionStorage.removeItem('ConsumerId');
        sessionStorage.setItem('ConsumerId', res.data[0].ConsumerId);
        getTasksRequest(workOrderId);
        history.push(`/WorkOrder/${workOrderId}/summary`);
      }
      ).catch(err => { });
  }

  function handleRouteCustomer(consumerId) {
    axios
    .get(`/GetConsumerById/` + consumerId)
    .then(res => {
      const response = JSON.stringify(res.data[0]);
        sessionStorage.removeItem('SearhResult');
        sessionStorage.setItem('SearhResult', response);
        sessionStorage.removeItem('ConsumerId');
        sessionStorage.setItem('ConsumerId', res.data[0].ConsumerId);
        history.push('/overview');
    })
    .catch(error => { }); 
    
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <TableContainer className={`${classes.container} ${classes.divStyle}`}>
        <h4 className={classes.tableHeaderStyle}>{t('lblRecentlyViewCases')}</h4>
        <Table
          stickyHeader
          aria-label="sticky table"
          className={classes.table}
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell>{t('lblWorkCaseId')}</TableCell>
              <TableCell>{t('lblWorkOrderID')}</TableCell>
              <TableCell>{t('lblStatus')}</TableCell>
              <TableCell>{t('lblConsumerName')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recentCasesSearches ?
              recentCasesSearches.map(search => (
                <TableRow
                  key={search.WorkOrderId}
                  onClick={() => {
                    onRecentSearchClick(search)
                    handleRouteCases(search.WorkOrderId)
                  }}
                  hover
                  classes={{ hover: classes.hover }}
                  className={classes.tableRow}
                  style={{ cursor: 'pointer' }}
                >
                  <TableCell>{search.WorkCaseId}</TableCell>
                  <TableCell>{search.WorkOrderId}</TableCell>
                  <TableCell>{search.Status}</TableCell>
                  <TableCell>{search.CustomerFullName}</TableCell>
                </TableRow>
              )) : ''}
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer className={`${classes.container} ${classes.divStyle}`}>
        <h4 className={classes.tableHeaderStyle}>{t('lblRecentlyViewCustomers')}</h4>
        <Table
          stickyHeader
          aria-label="sticky table"
          className={classes.table}
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell>{t('lblConsumerId')}</TableCell>
              <TableCell>{t('lblConsumerName')}</TableCell>
              <TableCell>{t('lblCity')}</TableCell>
              <TableCell>{t('lblPostCode')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recentConsumerSearches ?
              recentConsumerSearches.map(search => (
                <TableRow
                  key={search.ConsumerId}
                  onClick={() => {
                    onRecentSearchClick(search)
                    handleRouteCustomer(search.ConsumerId)
                  }}
                  hover
                  classes={{ hover: classes.hover }}
                  className={classes.tableRow}
                  style={{ cursor: 'pointer' }}
                >
                  <TableCell>{search.ConsumerId}</TableCell>
                  <TableCell>{search.CustomerFullName}</TableCell>
                  <TableCell>{search.City}</TableCell>
                  <TableCell>{search.PostCode}</TableCell>
                </TableRow>
              )) : ''}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default connect(state => ({
  tasks: state.tasks1,
}), {
  getTasksRequest,
})(RecentSearches);